/// Menu
import Metismenu from "metismenujs";
import React, {
  Component,
  useContext,
  useEffect,
  useState,
} from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link, useLocation } from "react-router-dom";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";

import { GlobalSet } from "../../components/global/GlobalProvider";
import { ThemeContext } from "../../../context/ThemeContext";

/* =========================================================
   METIS MENU WRAPPER
========================================================= */

class MM extends Component {
  componentDidMount() {
    if (this.el) {
      this.mm = new Metismenu(this.el);
    }
  }

  componentWillUnmount() {
    if (this.mm && typeof this.mm.dispose === "function") {
      this.mm.dispose();
    }
  }

  render() {
    return (
      <div className="mm-wrapper">
        <ul
          className="metismenu"
          id="menu"
          ref={(el) => {
            this.el = el;
          }}
        >
          {this.props.children}
        </ul>
      </div>
    );
  }
}

/* =========================================================
   SIDEBAR
========================================================= */

const SideBar = () => {
  const { BaseUrl } = GlobalSet();

  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
  } = useContext(ThemeContext);

  const location = useLocation();

  const [hideOnScroll, setHideOnScroll] = useState(true);

  /* =========================================================
     CURRENT PATH
  ========================================================= */

  const path = location.pathname;

  /* =========================================================
     MOBILE MENU + HEART
  ========================================================= */

  useEffect(() => {
    const navButton =
      document.querySelector(".nav-control");

    const mainWrapper =
      document.querySelector("#main-wrapper");

    const heart =
      document.querySelector(".heart");

    const toggleSidebar = () => {
      if (mainWrapper) {
        mainWrapper.classList.toggle("menu-toggle");
      }
    };

    const heartBlast = () => {
      if (heart) {
        heart.classList.toggle("heart-blast");
      }
    };

    if (navButton) {
      navButton.addEventListener(
        "click",
        toggleSidebar
      );
    }

    if (heart) {
      heart.addEventListener(
        "click",
        heartBlast
      );
    }

    /* CLEANUP */

    return () => {
      if (navButton) {
        navButton.removeEventListener(
          "click",
          toggleSidebar
        );
      }

      if (heart) {
        heart.removeEventListener(
          "click",
          heartBlast
        );
      }
    };
  }, []);

  /* =========================================================
     CLOSE MOBILE SIDEBAR
  ========================================================= */

  const toggleMenu = () => {
    const mainWrapper =
      document.querySelector("#main-wrapper");

    if (mainWrapper) {
      mainWrapper.classList.remove(
        "menu-toggle"
      );
    }
  };

  /* =========================================================
     SCROLL POSITION
  ========================================================= */

  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow =
        currPos.y > prevPos.y;

      if (isShow !== hideOnScroll) {
        setHideOnScroll(isShow);
      }
    },
    [hideOnScroll]
  );

  /* =========================================================
     ACTIVE ROUTE HELPERS
  ========================================================= */

  const isActive = (route) => {
    if (route === "/") {
      return path === "/";
    }

    return (
      path === route ||
      path.startsWith(`${route}/`)
    );
  };

  const isAnyActive = (routes = []) => {
    return routes.some((route) =>
      isActive(route)
    );
  };

  /* =========================================================
     MENU GROUPS
  ========================================================= */

  const accountRoutes = [
    "/app-profile",
  ];

  const fundRoutes = [
    "/deposit",
    "/withdraw",
  ];

  const projectRoutes = [
    "/smart-module",
    "/basic-activation",
    "/investment-log",
  ];

  const reportRoutes = [
    "/income-history",
    "/transaction-history",
    "/investment-log",
  ];

  const securityRoutes = [
    "/change-password",
    "/security",
  ];

  const partnerRoutes = [
    "/affiliate",
    "/my-smart-team",
  ];

  const liveTeamRoutes = [
    "/affiliate",
  ];

  const supportRoutes = [
    "/support-ticket",
  ];

  /* =========================================================
     SIDEBAR CLASS
  ========================================================= */

  const sidebarClass = [
    "dlabnav",
    "z-3",
    iconHover || "",
    sidebarposition?.value === "fixed" &&
    sidebarLayout?.value === "horizontal" &&
    headerposition?.value === "static" &&
    hideOnScroll
      ? "fixed"
      : "",
  ]
    .filter(Boolean)
    .join(" ");

  /* =========================================================
     VIEW
  ========================================================= */

  return (
    <>
      <SidebarStyles />

      <div className={sidebarClass}>
        <PerfectScrollbar className="dlabnav-scroll">

          {/* ===============================================
              BRAND / USER AREA
          ================================================ */}

          <div className="rp-sidebar-head">
            <div className="rp-sidebar-brand-icon">
              <i className="fas fa-building"></i>
            </div>

            <div className="rp-sidebar-brand-copy">
              <strong>
                Rajya Properties
              </strong>

              <span>
                Member Dashboard
              </span>
            </div>
          </div>

          {/* ===============================================
              MENU LABEL
          ================================================ */}

          <div className="rp-menu-label">
            MAIN MENU
          </div>

          <MM>

            {/* =============================================
                DASHBOARD
            ============================================== */}

            <li
              className={
                path === "/"
                  ? "mm-active"
                  : ""
              }
            >
              <Link
                to="/"
                onClick={toggleMenu}
                className="ai-icon"
              >
                <span className="rp-nav-icon">
                  <i className="fas fa-home"></i>
                </span>

                <span className="nav-text">
                  Dashboard
                </span>
              </Link>
            </li>

            {/* =============================================
                MY ACCOUNT
            ============================================== */}

            <li
              className={
                isAnyActive(accountRoutes)
                  ? "mm-active"
                  : ""
              }
            >
              <Link
                className="has-arrow ai-icon"
                to="#"
                onClick={(e) =>
                  e.preventDefault()
                }
              >
                <span className="rp-nav-icon">
                  <i className="fas fa-user-circle"></i>
                </span>

                <span className="nav-text">
                  My Account
                </span>
              </Link>

              <ul>
                <li
                  className={
                    isActive("/app-profile")
                      ? "mm-active"
                      : ""
                  }
                >
                  <Link
                    to="/app-profile"
                    onClick={toggleMenu}
                  >
                    <i className="fas fa-user"></i>

                    <span>
                      My Profile
                    </span>
                  </Link>
                </li>
              </ul>
            </li>

            {/* =============================================
                FUND
            ============================================== */}

            <li
              className={
                isAnyActive(fundRoutes)
                  ? "mm-active"
                  : ""
              }
            >
              <Link
                className="has-arrow ai-icon"
                to="#"
                onClick={(e) =>
                  e.preventDefault()
                }
              >
                <span className="rp-nav-icon">
                  <i className="fas fa-wallet"></i>
                </span>

                <span className="nav-text">
                  Fund
                </span>
              </Link>

              <ul>
                <li
                  className={
                    isActive("/deposit")
                      ? "mm-active"
                      : ""
                  }
                >
                  <Link
                    to="/deposit"
                    onClick={toggleMenu}
                  >
                    <i className="fas fa-arrow-down"></i>

                    <span>
                      Deposit
                    </span>
                  </Link>
                </li>

                <li
                  className={
                    isActive("/withdraw")
                      ? "mm-active"
                      : ""
                  }
                >
                  <Link
                    to="/withdraw"
                    onClick={toggleMenu}
                  >
                    <i className="fas fa-arrow-up"></i>

                    <span>
                      Withdraw Asset
                    </span>
                  </Link>
                </li>
              </ul>
            </li>

            {/* =============================================
                PROJECT & SHARE
            ============================================== */}

            <li
              className={
                isAnyActive(projectRoutes)
                  ? "mm-active"
                  : ""
              }
            >
              <Link
                className="has-arrow ai-icon"
                to="#"
                onClick={(e) =>
                  e.preventDefault()
                }
              >
                <span className="rp-nav-icon">
                  <i className="fas fa-chart-line"></i>
                </span>

                <span className="nav-text">
                  Project &amp; Share
                </span>
              </Link>

              <ul>
                <li
                  className={
                    isActive("/booking-land")
                      ? "mm-active"
                      : ""
                  }
                >
                  <Link
                    to="/booking-land"
                    onClick={toggleMenu}
                  >
                    <i className="fas fa-th-large"></i>

                    <span>
                      Land Booking
                    </span>
                  </Link>
                </li>

                <li
                  className={
                    isActive("/smart-module")
                      ? "mm-active"
                      : ""
                  }
                >
                  <Link
                    to="/smart-module"
                    onClick={toggleMenu}
                  >
                    <i className="fas fa-th-large"></i>

                    <span>
                      Smart Module
                    </span>
                  </Link>
                </li>

                <li
                  className={
                    isActive("/basic-activation")
                      ? "mm-active"
                      : ""
                  }
                >
                  <Link
                    to="/basic-activation"
                    onClick={toggleMenu}
                  >
                    <i className="fas fa-id-badge"></i>

                    <span>
                      Membership
                    </span>
                  </Link>
                </li>

                <li
                  className={
                    isActive("/investment-log")
                      ? "mm-active"
                      : ""
                  }
                >
                  <Link
                    to="/investment-log"
                    onClick={toggleMenu}
                  >
                    <i className="fas fa-clipboard-list"></i>

                    <span>
                      Account Log
                    </span>
                  </Link>
                </li>
              </ul>
            </li>

            {/* =============================================
                REPORT
            ============================================== */}

            <li
              className={
                isAnyActive(reportRoutes)
                  ? "mm-active"
                  : ""
              }
            >
              <Link
                className="has-arrow ai-icon"
                to="#"
                onClick={(e) =>
                  e.preventDefault()
                }
              >
                <span className="rp-nav-icon">
                  <i className="fas fa-file-alt"></i>
                </span>

                <span className="nav-text">
                  Report
                </span>
              </Link>

              <ul>
                <li
                  className={
                    isActive("/income-history")
                      ? "mm-active"
                      : ""
                  }
                >
                  <Link
                    to="/income-history"
                    onClick={toggleMenu}
                  >
                    <i className="fas fa-chart-bar"></i>

                    <span>
                      Income History
                    </span>
                  </Link>
                </li>

                <li
                  className={
                    isActive(
                      "/transaction-history"
                    )
                      ? "mm-active"
                      : ""
                  }
                >
                  <Link
                    to="/transaction-history"
                    onClick={toggleMenu}
                  >
                    <i className="fas fa-exchange-alt"></i>

                    <span>
                      Transaction History
                    </span>
                  </Link>
                </li>

                <li
                  className={
                    isActive("/investment-log")
                      ? "mm-active"
                      : ""
                  }
                >
                  <Link
                    to="/investment-log"
                    onClick={toggleMenu}
                  >
                    <i className="fas fa-history"></i>

                    <span>
                      Investment Log
                    </span>
                  </Link>
                </li>
              </ul>
            </li>

            {/* =============================================
                SECURITY
            ============================================== */}

            <li
              className={
                isAnyActive(securityRoutes)
                  ? "mm-active"
                  : ""
              }
            >
              <Link
                className="has-arrow ai-icon"
                to="#"
                onClick={(e) =>
                  e.preventDefault()
                }
              >
                <span className="rp-nav-icon">
                  <i className="fas fa-shield-alt"></i>
                </span>

                <span className="nav-text">
                  Security
                </span>
              </Link>

              <ul>
                <li
                  className={
                    isActive(
                      "/change-password"
                    )
                      ? "mm-active"
                      : ""
                  }
                >
                  <Link
                    to="/change-password"
                    onClick={toggleMenu}
                  >
                    <i className="fas fa-key"></i>

                    <span>
                      Change Password
                    </span>
                  </Link>
                </li>

                <li
                  className={
                    isActive("/security")
                      ? "mm-active"
                      : ""
                  }
                >
                  <Link
                    to="/security"
                    onClick={toggleMenu}
                  >
                    <i className="fas fa-user-shield"></i>

                    <span>
                      Security
                    </span>
                  </Link>
                </li>
              </ul>
            </li>

            {/* =============================================
                PARTNER
            ============================================== */}

            <li
              className={
                isAnyActive(partnerRoutes)
                  ? "mm-active"
                  : ""
              }
            >
              <Link
                className="has-arrow ai-icon"
                to="#"
                onClick={(e) =>
                  e.preventDefault()
                }
              >
                <span className="rp-nav-icon">
                  <i className="fas fa-users"></i>
                </span>

                <span className="nav-text">
                  Partner
                </span>
              </Link>

              <ul>
                <li
                  className={
                    isActive("/affiliate")
                      ? "mm-active"
                      : ""
                  }
                >
                  <Link
                    to="/affiliate"
                    onClick={toggleMenu}
                  >
                    <i className="fas fa-user-friends"></i>

                    <span>
                      Partner
                    </span>
                  </Link>
                </li>

                <li
                  className={
                    isActive(
                      "/my-smart-team"
                    )
                      ? "mm-active"
                      : ""
                  }
                >
                  <Link
                    to="/my-smart-team"
                    onClick={toggleMenu}
                  >
                    <i className="fas fa-sitemap"></i>

                    <span>
                      Smart Team
                    </span>
                  </Link>
                </li>
              </ul>
            </li>

            {/* =============================================
                LIVE TEAM
            ============================================== */}

            <li
              className={
                isAnyActive(liveTeamRoutes)
                  ? "mm-active"
                  : ""
              }
            >
              <Link
                className="has-arrow ai-icon"
                to="#"
                onClick={(e) =>
                  e.preventDefault()
                }
              >
                <span className="rp-nav-icon">
                  <i className="fas fa-broadcast-tower"></i>
                </span>

                <span className="nav-text">
                  Live Team
                </span>
              </Link>

              <ul>
                <li>
                  <Link
                    to="/affiliate"
                    onClick={toggleMenu}
                  >
                    <i className="fas fa-level-up-alt"></i>

                    <span>
                      Grow Up
                    </span>
                  </Link>
                </li>
              </ul>
            </li>

            {/* =============================================
                SUPPORT
            ============================================== */}

            <li
              className={
                isAnyActive(supportRoutes)
                  ? "mm-active"
                  : ""
              }
            >
              <Link
                className="has-arrow ai-icon"
                to="#"
                onClick={(e) =>
                  e.preventDefault()
                }
              >
                <span className="rp-nav-icon">
                  <i className="fas fa-headset"></i>
                </span>

                <span className="nav-text">
                  Support Center
                </span>
              </Link>

              <ul>
                <li
                  className={
                    isActive(
                      "/support-ticket"
                    )
                      ? "mm-active"
                      : ""
                  }
                >
                  <Link
                    to="/support-ticket"
                    onClick={toggleMenu}
                  >
                    <i className="fas fa-ticket-alt"></i>

                    <span>
                      Support Ticket
                    </span>
                  </Link>
                </li>
              </ul>
            </li>
          </MM>

          {/* ===============================================
              CONTACT CARD
          ================================================ */}

          <div className="rp-support-card">
            <div className="rp-support-icon">
              <i className="fas fa-headset"></i>
            </div>

            <div className="rp-support-content">
              <strong>Need Help?</strong>

              <p>
                Our support team is ready to
                assist you.
              </p>

              <Link
                to="/support-ticket"
                onClick={toggleMenu}
              >
                Contact Support
                <i className="fas fa-arrow-right"></i>
              </Link>
            </div>
          </div>

          {/* ===============================================
              COPYRIGHT
          ================================================ */}

          <div className="rp-sidebar-footer">
            <div className="rp-footer-logo">
              <i className="fas fa-building"></i>
            </div>

            <p>
              <strong>
                Rajya Properties
              </strong>
            </p>

            <span>
              © {new Date().getFullYear()} All
              Rights Reserved
            </span>
          </div>
        </PerfectScrollbar>
      </div>
    </>
  );
};

/* =========================================================
   CSS
========================================================= */

const SidebarStyles = () => (
  <style>{`
    .dlabnav {
      --rp-sidebar-primary: #135846;
      --rp-sidebar-primary-dark: #0b4032;
      --rp-sidebar-soft: #edf6f3;
      --rp-sidebar-text: #263238;
      --rp-sidebar-muted: #7d8985;
      --rp-sidebar-border: #edf0ef;

      background: #ffffff;
      border-right: 1px solid var(--rp-sidebar-border);
      box-shadow: 4px 0 20px rgba(19, 88, 70, 0.035);
    }

    .dlabnav .dlabnav-scroll {
      padding: 15px 13px 25px;
    }

    /* ===========================
       BRAND
    =========================== */

    .rp-sidebar-head {
      display: flex;
      align-items: center;
      gap: 11px;
      margin: 3px 4px 20px;
      padding: 14px;
      border: 1px solid #e8efec;
      border-radius: 15px;
      background:
        linear-gradient(
          135deg,
          #f7faf9,
          #eef6f3
        );
    }

    .rp-sidebar-brand-icon {
      flex: 0 0 43px;
      width: 43px;
      height: 43px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 12px;
      background: var(--rp-sidebar-primary);
      color: #fff;
      font-size: 17px;
      box-shadow:
        0 7px 16px
        rgba(19, 88, 70, 0.16);
    }

    .rp-sidebar-brand-copy {
      min-width: 0;
    }

    .rp-sidebar-brand-copy strong {
      display: block;
      overflow: hidden;
      margin-bottom: 2px;
      color: #17231f;
      font-size: 13px;
      font-weight: 850;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .rp-sidebar-brand-copy span {
      display: block;
      color: var(--rp-sidebar-muted);
      font-size: 9px;
      font-weight: 600;
    }

    /* ===========================
       MENU LABEL
    =========================== */

    .rp-menu-label {
      padding: 0 13px;
      margin-bottom: 7px;
      color: #a0aaa6;
      font-size: 9px;
      font-weight: 900;
      letter-spacing: 0.8px;
    }

    /* ===========================
       MAIN MENU
    =========================== */

    .dlabnav .metismenu {
      padding: 0;
      margin: 0;
    }

    .dlabnav .metismenu > li {
      position: relative;
      margin-bottom: 4px;
    }

    .dlabnav .metismenu > li > a {
      min-height: 48px;
      display: flex;
      align-items: center;
      position: relative;
      padding: 7px 12px !important;
      border-radius: 12px;
      color: #53605c;
      font-size: 13px;
      font-weight: 700;
      text-decoration: none;
      transition: all 0.18s ease;
    }

    .dlabnav .metismenu > li > a:hover {
      background: #f5f8f7;
      color: var(--rp-sidebar-primary);
    }

    .dlabnav
      .metismenu
      > li.mm-active
      > a {
      background:
        linear-gradient(
          135deg,
          #edf7f4,
          #f4faf8
        );
      color: var(--rp-sidebar-primary);
      font-weight: 800;
    }

    .dlabnav
      .metismenu
      > li.mm-active
      > a::before {
      content: "";
      position: absolute;
      left: -13px;
      top: 11px;
      width: 4px;
      height: 27px;
      border-radius: 0 6px 6px 0;
      background: var(--rp-sidebar-primary);
    }

    /* ===========================
       ICON
    =========================== */

    .rp-nav-icon {
      flex: 0 0 34px;
      width: 34px;
      height: 34px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      border-radius: 10px;
      background: #f3f6f5;
      color: #65716d;
      font-size: 13px;
      transition: all 0.18s ease;
    }

    .dlabnav
      .metismenu
      > li
      > a:hover
      .rp-nav-icon {
      background: #e8f3ef;
      color: var(--rp-sidebar-primary);
    }

    .dlabnav
      .metismenu
      > li.mm-active
      > a
      .rp-nav-icon {
      background: var(--rp-sidebar-primary);
      color: #fff;
      box-shadow:
        0 6px 13px
        rgba(19, 88, 70, 0.14);
    }

    .dlabnav .nav-text {
      flex: 1;
      line-height: 1.35;
    }

    /* ===========================
       ARROW
    =========================== */

    .dlabnav
      .metismenu
      .has-arrow::after {
      right: 15px;
      width: 6px;
      height: 6px;
      border-width: 0 1.5px 1.5px 0;
      border-color: #9aa4a0;
    }

    .dlabnav
      .metismenu
      .mm-active
      > .has-arrow::after {
      border-color:
        var(--rp-sidebar-primary);
    }

    /* ===========================
       SUB MENU
    =========================== */

    .dlabnav .metismenu ul {
      padding: 5px 0 5px 45px;
      margin: 0;
    }

    .dlabnav .metismenu ul li {
      margin: 2px 0;
    }

    .dlabnav .metismenu ul li a {
      min-height: 37px;
      display: flex;
      align-items: center;
      gap: 9px;
      position: relative;
      padding: 7px 11px !important;
      border-radius: 9px;
      color: #75807c;
      font-size: 11px;
      font-weight: 650;
      text-decoration: none;
      transition: all 0.16s ease;
    }

    .dlabnav .metismenu ul li a i {
      width: 15px;
      color: #a0aaa6;
      font-size: 9px;
      text-align: center;
    }

    .dlabnav
      .metismenu
      ul
      li
      a:hover {
      padding-left: 14px !important;
      background: #f7f9f8;
      color: var(--rp-sidebar-primary);
    }

    .dlabnav
      .metismenu
      ul
      li.mm-active
      > a {
      background: #eef6f3;
      color: var(--rp-sidebar-primary);
      font-weight: 800;
    }

    .dlabnav
      .metismenu
      ul
      li.mm-active
      > a
      i {
      color: var(--rp-sidebar-primary);
    }

    /* ===========================
       SUPPORT CARD
    =========================== */

    .rp-support-card {
      position: relative;
      overflow: hidden;
      margin: 22px 4px 15px;
      padding: 17px;
      border-radius: 16px;
      background:
        linear-gradient(
          145deg,
          #124f40,
          #0b392e
        );
      color: #fff;
      box-shadow:
        0 10px 24px
        rgba(19, 88, 70, 0.14);
    }

    .rp-support-card::after {
      content: "";
      position: absolute;
      right: -35px;
      bottom: -45px;
      width: 110px;
      height: 110px;
      border-radius: 50%;
      background:
        rgba(255, 255, 255, 0.05);
    }

    .rp-support-icon {
      width: 39px;
      height: 39px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 11px;
      border-radius: 11px;
      background:
        rgba(255, 255, 255, 0.1);
      color: #d8b46d;
      font-size: 15px;
    }

    .rp-support-content {
      position: relative;
      z-index: 1;
    }

    .rp-support-content strong {
      display: block;
      margin-bottom: 4px;
      font-size: 13px;
      font-weight: 850;
    }

    .rp-support-content p {
      margin: 0 0 11px;
      color:
        rgba(255, 255, 255, 0.67);
      font-size: 10px;
      line-height: 1.55;
    }

    .rp-support-content a {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      color: #fff;
      font-size: 10px;
      font-weight: 800;
      text-decoration: none;
    }

    .rp-support-content a i {
      font-size: 8px;
    }

    /* ===========================
       FOOTER
    =========================== */

    .rp-sidebar-footer {
      padding: 13px 7px 7px;
      border-top: 1px solid
        var(--rp-sidebar-border);
      text-align: center;
    }

    .rp-footer-logo {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 6px;
      border-radius: 9px;
      background: #edf6f3;
      color: var(--rp-sidebar-primary);
      font-size: 11px;
    }

    .rp-sidebar-footer p {
      margin: 0 0 2px;
      color: #3f4a46;
      font-size: 10px;
    }

    .rp-sidebar-footer span {
      display: block;
      color: #9aa3a0;
      font-size: 8px;
    }

    /* ===========================
       COLLAPSED SIDEBAR
    =========================== */

    #main-wrapper.menu-toggle
      .dlabnav
      .rp-sidebar-brand-copy,
    #main-wrapper.menu-toggle
      .dlabnav
      .rp-menu-label,
    #main-wrapper.menu-toggle
      .dlabnav
      .rp-support-card,
    #main-wrapper.menu-toggle
      .dlabnav
      .rp-sidebar-footer {
      transition: opacity 0.2s ease;
    }

    /* ===========================
       RESPONSIVE
    =========================== */

    @media (max-width: 991px) {
      .dlabnav .dlabnav-scroll {
        padding-top: 12px;
      }

      .rp-sidebar-head {
        margin-top: 0;
      }

      .dlabnav
        .metismenu
        > li
        > a {
        min-height: 50px;
      }

      .dlabnav
        .metismenu
        ul
        li
        a {
        min-height: 40px;
        font-size: 12px;
      }
    }
  `}</style>
);

export default SideBar;